export const filterActionTypes = {
    SET_ITEM_FILTERS: 'SET_ITEM_FILTERS'
}